import React, { useRef } from 'react'
import './index.less'

declare module 'react' {
    interface InputHTMLAttributes<T> extends HTMLAttributes<T> {
      directory?: string | boolean;
      webkitdirectory?: string | boolean;
    }
}

export interface IUpload{
    // onDrop: (e: React.DragEvent<HTMLDivElement>)=>void,
    onChange?: (files: Array<File>)=>void,
    onClick?: React.MouseEventHandler<HTMLDivElement>,
    directory?: boolean,
    multiple?: boolean,
    disabled?: boolean,
    accept?: string,
    children?: React.ReactNode,
    style?:React.CSSProperties,
}

export default function Upload({
  onChange,
  directory,
  multiple = false,
  children,
  style,
  onClick,
  disabled = false,
  accept,
}: IUpload) {
  const id = String(new Date().getTime() + Math.random())
  const $input = useRef<HTMLInputElement | undefined>()

  const _onChange = (e) => {
    upload(Object.values(e.target.files))
  }

  const upload = (files) => {
    $input.current.value = ''
    onChange?.(Object.values(files))
  }

  const onDragEnd = (e) => {
    e.stopPropagation()
    e.preventDefault()
  }
  const onDragOver = (e) => {
    e.stopPropagation()
    e.preventDefault()
  }

  return <div
    className="meinian-upload"
    style={style}
    onDragEnd={onDragEnd}
    onDrop={(e) => {
      e.stopPropagation()
      e.preventDefault()
      upload(e.dataTransfer.files)
    }}
    onDragOver={onDragOver}
    onClick={onClick}
  >
    <label className="input-button" htmlFor={id}>
      {children || '上传'}
    </label>
    <input
      type="file"
      directory={directory}
      webkitdirectory={directory}
      disabled={disabled}
      id={id}
      accept={accept}
      className="meinian-input-file"
      ref={$input}
      onChange={_onChange}
      multiple={multiple}
    />
  </div>
}
